<section id="experiencia" class="section-space" appRevealOnScroll>
  <div class="container-page">
    <app-section-heading [title]="i18n.t().experienceTitle" icon="briefcase" />

    <ol class="relative space-y-6 border-l border-brand-500/30 pl-6 sm:pl-8">
      @for (job of experiences(); track job.company + job.period) {
        <li class="relative">
          <span
            class="absolute -left-[1.9rem] top-5 h-3 w-3 rounded-full border-2 border-brand-400 bg-surface-950 sm:-left-[2.4rem]"
          ></span>

          <article class="card-surface p-5 sm:p-6">
            <div class="flex flex-wrap items-center gap-2">
              <h3 class="text-lg font-semibold text-ink-100">
                {{ job.title }}
                @if (job.type) {
                  <span class="font-normal text-ink-400">({{ job.type }})</span>
                }
              </h3>
              @if (job.current) {
                <span
                  class="rounded-full bg-emerald-500/15 px-2.5 py-0.5 text-xs font-semibold text-emerald-400"
                >
                  {{ i18n.t().currentBadge }}
                </span>
              }
            </div>

            <p class="mt-1 text-sm font-medium text-ink-300">{{ job.company }}</p>
            <p class="mt-1 text-sm text-ink-500">{{ job.period }} · {{ job.location }}</p>

            <p class="mt-4 text-sm leading-relaxed text-ink-400">{{ job.description }}</p>

            <ul class="mt-4 space-y-2 text-sm leading-relaxed text-ink-400">
              @for (item of job.responsibilities; track item) {
                <li class="flex gap-2">
                  <span class="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-400"></span>
                  <span>{{ item }}</span>
                </li>
              }
            </ul>

            @if (job.technologies.length) {
              <div class="mt-4 flex flex-wrap gap-2">
                @for (tech of job.technologies; track tech) {
                  <app-technology-badge [label]="tech" />
                }
              </div>
            }
          </article>
        </li>
      }
    </ol>
  </div>
</section>
